import { useEffect } from 'react'
import { swiper } from '../Swiper.js'

const SwiperComponent = () => {
  useEffect(() => {
    swiper.init()
  }, [])

  return (
    <div className="swiper swiper-gain-more">
      <div className="swiper-wrapper">
        {gainMoreData.records.map((record) => (
          <div key={record.id} className="swiper-slide b-gain-more">
            <div className="icon">
              <img src={record.image.url} alt={record.image.alt} />
            </div>
            <p>{record.text}</p>
          </div>
        ))}
      </div>
    </div>
  )
}
export default SwiperComponent
